/*
  RAD swatches - collection grid behaviour (our own code, no app).
  1. Click a swatch -> go to that colour's variant page.
  2. Hover a swatch (devices with a mouse) -> the product photo on that card switches to that colour; mouse out restores it.
  Markup comes from snippets/rad-swatches.liquid (.collectionSwatches > .swatchColor[data-url][data-image]).
*/
(function () {
  var SWATCH = '.collectionSwatches .swatchColor';

  function swatchFrom(target) {
    return target && target.closest ? target.closest(SWATCH) : null;
  }

  // Click: open the variant page (the whole card is a link, so stop its default navigation)
  document.addEventListener('click', function (e) {
    var swatch = swatchFrom(e.target);
    if (!swatch) return;
    var url = swatch.getAttribute('data-url');
    if (url) {
      e.preventDefault();
      window.location.href = url;
    }
  });

  // Hover image swap only where hover exists (not on phones/tablets)
  if (!(window.matchMedia && window.matchMedia('(hover: hover)').matches)) return;

  function cardImage(swatch) {
    var card = swatch.closest('.product-link');
    return card ? card.querySelector('.product__img') : null;
  }

  function swap(swatch) {
    var url = swatch.getAttribute('data-image');
    var img = cardImage(swatch);
    if (!url || !img) return;
    if (!img.hasAttribute('data-rad-orig-src')) {
      img.setAttribute('data-rad-orig-src', img.getAttribute('src') || '');
      if (img.hasAttribute('srcset')) img.setAttribute('data-rad-orig-srcset', img.getAttribute('srcset'));
    }
    img.removeAttribute('srcset');
    img.src = url;
    // hide the theme's second-photo hover layer so it doesn't cover the swapped photo
    var second = swatch.closest('.product-link').querySelector('.product__img-hover');
    if (second) second.style.opacity = '0';
  }

  function restore(swatch) {
    var img = cardImage(swatch);
    if (!img || !img.hasAttribute('data-rad-orig-src')) return;
    img.src = img.getAttribute('data-rad-orig-src');
    if (img.hasAttribute('data-rad-orig-srcset')) img.setAttribute('srcset', img.getAttribute('data-rad-orig-srcset'));
    img.removeAttribute('data-rad-orig-src');
    img.removeAttribute('data-rad-orig-srcset');
    var second = swatch.closest('.product-link').querySelector('.product__img-hover');
    if (second) second.style.opacity = '';
  }

  document.addEventListener('mouseover', function (e) {
    var swatch = swatchFrom(e.target);
    if (swatch) swap(swatch);
  });

  document.addEventListener('mouseout', function (e) {
    var swatch = swatchFrom(e.target);
    if (swatch && !swatch.contains(e.relatedTarget)) restore(swatch);
  });
})();
